var map = {
	"./": 68684,
	"./en": 907,
	"./en.js": 907,
	"./index": 68684,
	"./index.js": 68684,
	"./pt": 10543,
	"./pt.js": 10543
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 12595;
module.exports = webpackAsyncContext;